import buildLanguagesLists from "./buildLanguagesLists";

export default buildLanguagesLists;
